module.exports = __webpack_public_path__ + "static/media/Luther.c5244aaa.png";